import type { FC, ReactNode } from "react";
import { cn } from "@/utils/tailwind";

interface LayoutProps {
  children?: ReactNode;
  className?: string;
}

const Layout: FC<LayoutProps> = ({ children, className }) => {
  return (
    <div className="w-vw flex overflow-x-hidden!">
      <div
        className={cn(
          "mx-auto flex min-h-screen w-full max-w-[1230px] flex-col gap-8 px-4 sm:px-6 xl:px-0",
          className,
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default Layout;
